import { graphql, fetchQuery } from 'react-relay';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../common/constants.tsx';
import type { getNumProjectsJPBQuery } from './__generated__/getNumProjectsJPBQuery.graphql';

export const getNumProjects = async (cloudId: string) => {
	try {
		return await fetchQuery<getNumProjectsJPBQuery>(
			getRelayEnvironment(),
			graphql`
				query getNumProjectsJPBQuery($cloudId: ID!) {
					jira {
						allJiraProjects(cloudId: $cloudId, filter: {}) {
							totalCount
						}
					}
				}
			`,
			{ cloudId },
		)
			.toPromise()
			.then((data) => data?.jira?.allJiraProjects?.totalCount);
	} catch (error) {
		const typeGuardedError = error instanceof Error ? error : new Error('getNumProjects failed');
		fireErrorAnalytics({
			meta: {
				id: 'fetchNumProjects',
				packageName: PACKAGE_NAME,
				teamName: TEAM_NAME,
			},
			sendToPrivacyUnsafeSplunk: true,
			error: typeGuardedError,
		});
		return null;
	}
};
